import {
  User,
  DollarSign,
  Heart,
  ShoppingBag,
  Users,
  MapPin,
  Globe,
  FileText,
  Twitter,
  Facebook,
  Instagram,
  Activity,
  Watch,
  Building,
  Music,
  Tv,
} from "lucide-react";

// Category icons
export const categoryIcons = {
  personal: User,
  financial: DollarSign,
  health: Heart,
  preferences: ShoppingBag,
  social: Users,
  location: MapPin,
  browsing: Globe,
  other: FileText,
};

// Platform icons for integrations
export const platformIcons = {
  twitter: Twitter,
  facebook: Facebook,
  instagram: Instagram,
  google_fit: Activity,
  apple_health: Heart,
  fitbit: Watch,
  plaid_bank: Building,
  spotify: Music,
  netflix: Tv,
};
